// extracted by mini-css-extract-plugin
export default {"max_w_48":"agreementStyle_max_w_48__QImg2","max_w_24":"agreementStyle_max_w_24__cpADX","max_w_75":"agreementStyle_max_w_75__GFSaL"};